export const types = {
    SET_GET_CODE_COUNTRY: '[SETTINGS] SET GET CODE COUNTRY',
    SET_GET_CURRENCY: '[SETTINGS] SET GET CURRENCY',
    SET_GET_BANNERS: '[SETTINGS] SET GET BANNERS',
    SET_GET_COUNTRY: '[SETTINGS] SET GET COUNTRY'
}